import React from 'react'
import Dashboard from './Dashboard'

function StudentDashboard() {
  // Render the same content as Alumni Dashboard
  return <Dashboard />
}

export default StudentDashboard


